import { ISection, ITestPart } from '@/controllers/session/models/IQtiSession';
import DeliveryOptionsProvider from './DeliveryOptionsProvider';
import Section from './Section';
import Test from './Test';

class TestPart extends DeliveryOptionsProvider {
  private readonly _identifier: string;
  private readonly _submissionMode: string | null;
  private readonly _navigationMode: string | null;
  private _test!: Test;
  private readonly _sections: Array<Section> = new Array<Section>();

  constructor(identifier: string, submissionMode: string | null, navigationMode: string | null) {
    super();
    this._identifier = identifier;
    this._submissionMode = submissionMode;
    this._navigationMode = navigationMode;
  }

  get identifier(): string {
    return this._identifier;
  }

  get submissionMode(): string | null {
    return this._submissionMode;
  }

  get navigationMode(): string | null {
    return this._navigationMode;
  }

  get sections(): Array<Section> {
    return this._sections;
  }

  addSection(section: Section) {
    this._sections.push(section);
    section.testPart = this;
  }

  get test(): Test {
    return this._test;
  }

  set test(value: Test) {
    this._test = value;
  }

  toTestPartInterface(): ITestPart {
    const convertedSections: Array<ISection> = this.sections
      .map((section) => section.toSectionInterface())
      .filter(
        (section) =>
          (section.items && section.items.length > 0) ||
          section.state != 0 ||
          (section.deliveryOptions && section.deliveryOptions.length > 0)
      );
    return {
      identifier: this.identifier,
      sections: convertedSections.length > 0 ? convertedSections : undefined,
      deliveryOptions: this.getDeliveryOptionsToSave(),
    };
  }
}

export default TestPart;
